import "../css/NotFound.css";

import Image404 from "../assets/img/Image404.png";


import { Link } from "react-router-dom";



function GeneralNotFound() {

  return (
    <div className="not-found">
      <header className="not-found-header">
        <h1>404 - Not Found</h1>
        <h2>Oops! It Looks Like You've Hit a Roadblock.</h2>
        <p>But don’t worry, every great journey has its detours.</p>
      </header>

      <div className="not-found-visual">
        <img src={Image404} alt="Winding Path" className="not-found-image" />
        <div className="interactive-elements">
          {/*
          <a href="/content/specialty/programming" className="path-link">Programming Courses</a>
          <a href="/courses/mindset" className="path-link">Mindset Courses</a>
          */}
        </div>
      </div>

      <div className="not-found-actions">
        <p>"The only limit to our realization of tomorrow is our doubts of today." – Franklin D. Roosevelt</p>
        {/*
        <input type="text" placeholder="Search for courses..." className="search-bar" />
        */}
        <Link to="/content/coaching/schedule/book-now" className="btn-explore">Explore Coaching</Link>
      </div>

      <footer className="not-found-footer">
        {/*
        <p>Join our community and stay updated!</p>
        <Link to="/community" className="btn-join">Join Us</Link>
        */}
      </footer>
    </div>
  );

}



export {
    GeneralNotFound,
};

